export default __webpack_public_path__ + "static/media/Deed of Contract - Img - Final (2)_11.86934605.jpg";